"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _DatePicker = require("../DatePicker");
var _Select = require("../Select");
var _TimeLine = _interopRequireWildcard(require("../TimeLine"));
var _Typography = _interopRequireDefault(require("../Typography"));
var _intlTs = require("@gogame/intl-ts");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["minDate", "maxDate"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _toArray(r) { return _arrayWithHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var EMPTY = [];
var StatusPlanner = function StatusPlanner(_ref) {
  var children = _ref.children,
    _ref$idPropKey = _ref.idPropKey,
    idPropKey = _ref$idPropKey === void 0 ? 'state' : _ref$idPropKey,
    _ref$datePropKey = _ref.datePropKey,
    datePropKey = _ref$datePropKey === void 0 ? 'date' : _ref$datePropKey,
    _ref$addStatusLabel = _ref.addStatusLabel,
    addStatusLabel = _ref$addStatusLabel === void 0 ? 'Schedule status' : _ref$addStatusLabel,
    fullWidth = _ref.fullWidth,
    readOnlyCurrent = _ref.readOnlyCurrent,
    _ref$withCurrent = _ref.withCurrent,
    withCurrent = _ref$withCurrent === void 0 ? true : _ref$withCurrent,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? EMPTY : _ref$value,
    onChange = _ref.onChange,
    disabled = _ref.disabled;
  var _useMemo = (0, _react.useMemo)(function () {
      return withCurrent ? value : [null].concat(_toConsumableArray(value));
    }, [value, withCurrent]),
    _useMemo2 = _toArray(_useMemo),
    current = _useMemo2[0],
    planned = _useMemo2.slice(1);
  var currentId = current === null || current === void 0 ? void 0 : current[idPropKey];
  var planes = _react.Children.toArray(children).filter(function (item) {
    return /*#__PURE__*/(0, _react.isValidElement)(item);
  }).map(function (_ref2, i) {
    var childProps = _ref2.props;
    return _objectSpread({
      id: i
    }, childProps);
  });
  var planOptions = (0, _react.useMemo)(function () {
    var valueDates = planes.map(function (_ref3) {
      var _value$find;
      var id = _ref3.id;
      return (_value$find = value.find(function (v) {
        return v[idPropKey] === id;
      })) === null || _value$find === void 0 ? void 0 : _value$find[datePropKey];
    });
    return planes.map(function (_ref4, currentIndex, array) {
      var id = _ref4.id,
        label = _ref4.label;
      var minSelectedDate = (0, _intlTs.fromUTCToTimeZone)((0, _intlTs.toDate)(_toConsumableArray(valueDates).reverse().slice(array.length - currentIndex).find(function (date) {
        return date;
      }))) || (!withCurrent || readOnlyCurrent ? _intlTs.dateFNS.startOfYesterday() : _intlTs.dateFNS.startOfToday());
      var maxSelectedDate = (0, _intlTs.fromUTCToTimeZone)((0, _intlTs.toDate)(valueDates.slice(currentIndex + 1).find(function (date) {
        return date;
      })));
      return _objectSpread({
        id: id,
        name: label,
        minDate: _intlTs.dateFNS.addDays(minSelectedDate, 1)
      }, maxSelectedDate ? {
        maxDate: _intlTs.dateFNS.addDays(maxSelectedDate, -1)
      } : null);
    });
  }, [planes]);
  var unselectedPlanOptions = (0, _react.useMemo)(function () {
    var currentPlanIndex = Math.max(planes.findIndex(function (_ref5) {
      var id = _ref5.id;
      return id === currentId;
    }), 0);
    return planOptions.slice(withCurrent ? currentPlanIndex + 1 : currentPlanIndex).filter(function (_ref6) {
      var id = _ref6.id;
      return !value.some(function (v) {
        return v[idPropKey] === id;
      });
    }).map(function (_ref7) {
      var minDate = _ref7.minDate,
        maxDate = _ref7.maxDate,
        option = _objectWithoutProperties(_ref7, _excluded);
      return _objectSpread(_objectSpread({}, option), {}, {
        minDate: minDate,
        maxDate: maxDate,
        disabled: minDate && maxDate && _intlTs.dateFNS.differenceInDays(new Date(maxDate), new Date(minDate)) < 0
      });
    });
  }, [planOptions, value, currentId]);
  var handleSelectPlan = function handleSelectPlan(_ref8) {
    var _ref9 = _slicedToArray(_ref8, 1),
      pickedOption = _ref9[0];
    var unsortedNewValue = [].concat(_toConsumableArray(value), [_defineProperty(_defineProperty({}, idPropKey, pickedOption === null || pickedOption === void 0 ? void 0 : pickedOption.id), datePropKey, (0, _intlTs.toISOString)((0, _intlTs.fromTimeZoneToUTC)(pickedOption.minDate)))]);
    onChange({}, planes.reduce(function (acc, _ref1) {
      var id = _ref1.id;
      var item = unsortedNewValue.find(function (v) {
        return v[idPropKey] === id;
      });
      if (item) {
        return [].concat(_toConsumableArray(acc), [item]);
      }
      return acc;
    }, []));
  };
  var handleChangeInitialPlan = function handleChangeInitialPlan(_, v) {
    onChange({}, [_defineProperty(_defineProperty({}, idPropKey, v), datePropKey, (0, _intlTs.toISOString)((0, _intlTs.fromTimeZoneToUTC)(_intlTs.dateFNS.startOfToday())))]);
  };
  var currentPlanConfig = planes.find(function (plan) {
    return plan.id === currentId;
  });
  var everyUnselectedPlanOptionsDisabled = (0, _react.useMemo)(function () {
    return unselectedPlanOptions.every(function (_ref11) {
      var disabled = _ref11.disabled;
      return disabled;
    });
  }, [unselectedPlanOptions]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_TimeLine["default"], {
    withRemove: true,
    fullWidth: fullWidth,
    withAdd: !!unselectedPlanOptions.length,
    addOptions: unselectedPlanOptions,
    addLabel: addStatusLabel,
    addDisabled: disabled || everyUnselectedPlanOptionsDisabled,
    addTooltip: everyUnselectedPlanOptionsDisabled ? 'No date is available' : null,
    onAdd: handleSelectPlan,
    children: [withCurrent ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_TimeLine.TimeLineItem, {
      color: currentPlanConfig === null || currentPlanConfig === void 0 ? void 0 : currentPlanConfig.color,
      children: readOnlyCurrent ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography["default"], {
        children: currentPlanConfig === null || currentPlanConfig === void 0 ? void 0 : currentPlanConfig.label
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Select.Select, {
        options: planOptions,
        onChange: handleChangeInitialPlan,
        value: currentId,
        disabled: disabled
      })
    }) : null, planned.map(function (plan) {
      var id = plan[idPropKey],
        v = plan[datePropKey];
      var planConfig = planes.find(function (p) {
        return p.id === id;
      });
      var planOption = planOptions.find(function (p) {
        return p.id === id;
      });
      var handleChangeDate = function handleChangeDate(_, newV) {
        onChange({}, value === null || value === void 0 ? void 0 : value.map(function (vItem) {
          return vItem[idPropKey] === id ? _objectSpread(_objectSpread({}, vItem), {}, _defineProperty({}, datePropKey, newV)) : vItem;
        }));
      };
      var handleRemove = function handleRemove() {
        onChange({}, value === null || value === void 0 ? void 0 : value.filter(function (vItem) {
          return vItem[idPropKey] !== id;
        }));
      };
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_TimeLine.TimeLineItem, {
        color: planConfig === null || planConfig === void 0 ? void 0 : planConfig.color,
        error: planConfig === null || planConfig === void 0 ? void 0 : planConfig.error,
        removable: true,
        onRemove: handleRemove,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_DatePicker.GgDatePicker, {
          value: v,
          minDate: planOption.minDate,
          maxDate: planOption.maxDate,
          onChange: handleChangeDate,
          withTodayButton: false,
          label: planConfig === null || planConfig === void 0 ? void 0 : planConfig.label
        })
      }, "".concat(planConfig === null || planConfig === void 0 ? void 0 : planConfig.id, "_").concat(planConfig === null || planConfig === void 0 ? void 0 : planConfig.color, "_").concat(planConfig === null || planConfig === void 0 ? void 0 : planConfig.error, "_").concat(planConfig === null || planConfig === void 0 ? void 0 : planConfig.label));
    })]
  });
};
var _default = exports["default"] = StatusPlanner;